import { Card, CardContent } from '@mui/material';
import { MemreButton, MemreFlexBox, MemreText } from 'components/core';
import * as Color from 'core/colors';

type Props = {
  id: string;
  title: string;
  templateType: string;
  dragHandle: JSX.Element;
  handleDelete: any;
  handleClone: any;
  isSelected: boolean;
  handleSelect: (id: string) => void;
  isLoadingNewItem: boolean;
};

export default function ItemCard({
  id,
  title,
  templateType,
  dragHandle,
  handleDelete,
  handleClone,
  isSelected,
  handleSelect,
  isLoadingNewItem,
}: Props) {
  const isInstructional = templateType === 'instructional_contents';
  const topColor = isInstructional ? Color.cardPurple : Color.cardBlue; // Purple for instructional, light blue for others
  const outlineColor = isSelected ? (isInstructional ? Color.cardPurpleActive : Color.cardBlueActive) : 'transparent';
  return (
    <Card
      sx={{
        width: '100%',
        boxShadow: 3,
        flex: 1,
        borderRadius: 1,
        borderColor: Color.hexToRGB(Color.darkBlue, 0.2),
        borderTop: `8px solid ${topColor}`,
        outline: `2px solid ${outlineColor}`,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: isSelected ? Color.white : Color.veryLightGray,
      }}
    >
      <CardContent onClick={() => handleSelect(id)}>
        <MemreFlexBox gap={1.5} direction="row" align="center">
          {dragHandle}
          <MemreText sx={{ flex: 1 }} singleLine={true}>
            {title || 'Untitled'}
          </MemreText>
          <MemreFlexBox gap={0} direction="row" align="center">
            <MemreButton
              disabled={isLoadingNewItem}
              data-no-drag={true}
              iconName="copy"
              variant="icon"
              size="small"
              onClick={handleClone}
            />
            <MemreButton data-no-drag={true} iconName="trash" variant="icon" size="small" onClick={handleDelete} />
          </MemreFlexBox>
        </MemreFlexBox>
      </CardContent>
    </Card>
  );
}
